
import {generatePin, registerUser, validateUser, validationPin} from '../utils/backendRequest'
import { messageAlert } from "../utils/alerts/alerts";

export async function validateUserActions(url, data) {
    try {
        const validationUser = await validateUser(url, data);
        
        if (validationUser.data.code === 401.1) {
            const datos = {
                nombre: data.nombre,
                apellido: data.apellido,
                email: data.email
            };
            const generationPin = await generatePin('/getRegistrationPin', datos);

            if (generationPin.data.status !== 200) {
                messageAlert('info', 'Aviso', generationPin.data.message);
                return false;
            }

            return true;
        }

        messageAlert('info', 'Aviso', validationUser.data.message);
        return false;

    } catch (error) {
        const msg = error.response?.data?.message || 'Error inesperado';
        messageAlert('error', 'Error', msg);
        return false;
    }
}

export async function validatePinActions (url, data){
    const datos = {
        'email': data.email,
        'pin': data.code
    }
    const validatePin = await Promise.all([
        validationPin(url, datos)
    ]);
    if(validatePin[0].status !== 200){
        messageAlert('info','Aviso',validatePin[0].data.message);
        return false;
    }
    return true;
}

export async function registerUserActions (url, data){
    const registrationUser = await Promise.all([
        registerUser(url, data)
    ]);
    if(registrationUser[0].data.status !== 200){
        messageAlert('info','Aviso',registrationUser[0].data.message);
        return false;
    }
    return true;
}